export default __webpack_public_path__ + "static/media/J. Rockcliff Realtors.a50853dd.jpg";